<template>
  <div class="no-results">
    <div class="no-results__icon">
      <svg class="no-results__icon-ex-mark">
        <use xlink:href="#ex-mark"></use>
      </svg>
    </div>

    <div class="no-results__text">
      Комплекты оценочной документации не опубликованы
    </div>
  </div>
</template>

<script>
export default {
  name: "AppEmptyCompetence",
  methods: {
    getNextYear() {
      return new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 4);
    }
  }
};
</script>

<style lang="scss" scoped>
.no-results {
  display: flex;
  margin-top: 160px;
  align-items: center;

  &__icon {
    display: flex;
    width: 170px;
    height: 170px;
    border: 2px solid #c7c7c7;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  }

  &__icon-ex-mark {
    width: 27px;
    height: 85px;
  }

  &__text {
    margin-left: 52px;
    max-width: 523px;
    font-weight: 300;
    line-height: 46px;
    font-size: 30px;
    color: #000000;

    &--bold {
      font-weight: bold;
    }
  }
}
</style>
